"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixCell = void 0;
const react_1 = __importDefault(require("react"));
const MatrixBaseCell_1 = require("../MatrixBaseCell/MatrixBaseCell");
const constants_1 = require("../../helpers/constants");
const types_1 = require("../../types");
const Icon_1 = require("../../../Icon");
const icons_1 = require("../../../icons");
exports.MatrixCell = react_1.default.memo(function MatrixCell({ className, status = constants_1.STATUS_CELL.DISABLED, isDayCaption = false, isDemo = false, iconType, isLong = false, isDrawnLink = false, indexHour = -1, indexDay = -1, text }) {
    if (iconType) {
        return (react_1.default.createElement(MatrixBaseCell_1.MatrixBaseCell, { className: className, isDayCaption: isDayCaption, isLong: isLong, iconType: iconType },
            text,
            react_1.default.createElement(Icon_1.Icon, { src: iconType === types_1.CELL_ICON_TYPE.moon ? react_1.default.createElement(icons_1.NightIcon, null) : react_1.default.createElement(icons_1.DayIcon, null) })));
    }
    if (isDemo) {
        return react_1.default.createElement(MatrixBaseCell_1.MatrixBaseCell, { className: className, isDemo: true, status: status });
    }
    if (indexHour < 0 && indexDay < 0) {
        let cellType = types_1.CELL_TYPE.other;
        let dataSelectorId = `${types_1.CELL_TYPE.other}-cell-${indexDay}-${indexHour}`;
        if (indexHour === -1 && indexDay === -1) {
            cellType = types_1.CELL_TYPE.leftTopCaptionCell;
            dataSelectorId = 'left-top-caption-cell';
        }
        return (react_1.default.createElement(MatrixBaseCell_1.MatrixBaseCell, { className: className, text: text, indexHour: indexHour, indexDay: indexDay, isDayCaption: true, "cell-type": cellType, "data-selector-id": dataSelectorId }, indexDay < -1 && text));
    }
    let cellType = types_1.CELL_TYPE.mainCell;
    let dataSelectorId = `main-cell-${indexDay}-${indexHour}`;
    if (indexHour === -1 && indexDay >= 0) {
        cellType = types_1.CELL_TYPE.dayCaptionCell;
        dataSelectorId = `day-caption-cell-${indexDay}`;
    }
    if (indexHour >= 0 && indexDay === -1) {
        cellType = types_1.CELL_TYPE.hourCaptionCell;
        dataSelectorId = `hour-caption-cell-${indexHour}`;
    }
    return (react_1.default.createElement(MatrixBaseCell_1.MatrixBaseCell, { className: className, text: text, indexHour: indexHour, indexDay: indexDay, isDayCaption: isDayCaption, isDrawnLink: isDrawnLink, status: status, "cell-type": cellType, "data-selector-id": dataSelectorId }, indexDay >= 0 && indexHour < 0 && text));
});
//# sourceMappingURL=MatrixCell.js.map